import type { UserEntity } from '@/features/user/domain/entities/UserEntity'
import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { BrandMiniEntity } from '@/features/brand/domain/entities/BrandMiniEntity'
import type { ChannelEntity } from '@/features/channel/domain/entities/ChannelEntity'
import type { SalesManEntity } from '@/features/salesMan/domain/entities/SalesManEntity'

export class BranchFilterEntity {
  id?: number
  brand?: BrandMiniEntity
  user?: UserEntity
  name?: string
  service?: ServiceMiniEntity
  disabled?: boolean
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
  channels?: ChannelEntity[]
  searchWord?: string
  saleMan?: SalesManEntity
  isVip?: boolean
  hasMyMealSupport?: boolean
}
